import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormPergRespCadastro from '../../components/forms/FormPergRespCadastro';
import Body from '../../components/layouts/body';


class Questionarios extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Perguntas e Respostas" subtitulo="Cadastro" descricao="" />
            <Body>                
                <FormPergRespCadastro  />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(Questionarios));